import React, { useCallback, useRef, useState } from 'react';

import { useCompetencyDrawerState } from 'components/Develop/competencyDrawerSlice';
import { useLocalState } from 'components/RabbitOKRSidePanel/PrimaryPanel/Sections/Details/useLocalState';

import { MAX_OKR_NAME_LENGTH, MIN_OKR_NAME_LENGTH } from 'constants/ProjectConstants';

import InputLabel from 'uiToolkitV1/InputLabel';
import { InputV2 } from 'uiToolkitV1/InputV2';

export const InitiativeName = ({ text = '', onChange = () => {} }) => {
  const { isOpen: isCompetencyDrawerOpen } = useCompetencyDrawerState();
  const label = isCompetencyDrawerOpen
    ? 'What will you do to progress in this competency? *'
    : `What will you do to achieve the goal? *`;
  const placeholder = isCompetencyDrawerOpen
    ? 'State an actionable step such as "Attend leadership development program"'
    : `State an actionable step, such as "Launch a digital marketing campaign"`;

  const ref = useRef();
  const [localInitiativeName, setLocalInitiativeName] = useLocalState(text);

  const [error, setError] = useState('');

  const hasError = error.length > 0;

  const safeOnChange = () => {
    if (localInitiativeName === text) return;
    if (!hasError) onChange(localInitiativeName);
  };

  const onKeyDown = (ev) => {
    if (ev.key === 'Enter' && !hasError) {
      ref?.current?.blur();
    }
  };

  const handleLocalValueChange = (ev) => {
    const initiativeName = ev?.target?.value;

    setLocalInitiativeName(initiativeName);
    validateValue(initiativeName);
    onChange(initiativeName);
  };

  const validateValue = useCallback((initiativeName) => {
    /* check if some error is present. */
    if (initiativeName?.length < MIN_OKR_NAME_LENGTH) {
      setError('Cannot be empty');
      return;
    }

    if (initiativeName?.length > MAX_OKR_NAME_LENGTH) {
      setError(`Max ${MAX_OKR_NAME_LENGTH} characters`);
      return;
    }

    setError('');
  }, []);

  return (
    <InputLabel
      labelText={label}
      containerProps={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}
      captionText={error}
      captionVariant="error"
    >
      <InputV2
        placeholder={placeholder}
        ref={ref}
        isDashed
        value={localInitiativeName}
        onChange={handleLocalValueChange}
        onKeyDown={onKeyDown}
        onBlur={safeOnChange}
      />
    </InputLabel>
  );
};
